export const announcementTypesHeaders = [
  {
    title: 'Symbol',
    align: 'center',
    sortable: false,
    key: 'iconName',
    width: "1%"
  },
  {
    title: 'Název',
    align: 'left',
    sortable: true,
    key: 'name',
    width: "20%"
  },
  {
    title: 'Přiřazené obrazovky',
    align: 'left',
    sortable: false,
    key: 'displaysNames',
    width: "45%"
  },
  {
    title: 'Generující služba',
    align: 'center',
    sortable: false,
    key: 'serviceName',
    width: "20%"
  },
  {
    title: 'Akce',
    align: 'center',
    sortable: false,
    key: 'actions',
    width: "14%"
  }
];
